module.exports = __webpack_public_path__ + "static/media/stofferingen-03.776fd281.jpg";